import React from 'react';
import { Suggestion } from '@components/common/Suggestion';
import { MOBILE_APP_IOS_LINK } from '@fourthwall/utils/dist/links';
import { useWebViewBridge } from '@fourthwall/webview-bridge';
import { useShopStage } from '@hooks';
import { useKudosOrdersCountQuery } from '@modules/Dashboard/Home/queries/useKudosOrdersCountQuery';
import { routing } from '@utils/routing';
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss';
import sendAPersonalizedThankYouVideo from '../assets/send-a-personalized-thank-you-video.png';
export const useThankYouRecommendation = () => {
    const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss();
    const { methods, isWebView } = useWebViewBridge();
    const { shopStage, isLoading: isLoadingShopStage } = useShopStage();
    const { kudosOrdersCountQuery } = useKudosOrdersCountQuery([{ state: ['SENT'] }], {
        staleTime: 60_000,
    });
    return {
        thankYouRecommendation: {
            // "LOGIC: disappears after first video sent - ok"
            id: 'thankYou',
            enabled: shopStage.stage3 &&
                kudosOrdersCountQuery.data?.count === 0 &&
                recommendationsDismiss.thankYou.visible,
            isLoading: isLoadingShopStage || kudosOrdersCountQuery.isInitialLoading,
            suggestion: isWebView ? (React.createElement(Suggestion, { title: "Send a personalized thank you video", description: "Easily record and share a video to show your appreciation to supporters.", buttonLabel: "Send a thank you", imageUrl: sendAPersonalizedThankYouVideo, analytics: "sendThankYou", onButtonClick: async () => {
                    await methods.openMobilePage?.({
                        mobile_path: 'thank_yous_remaining',
                        // thank you page
                        url: routing.contributions.thankYous.self,
                    });
                } })) : (React.createElement(Suggestion, { title: "Send a personalized thank you video", description: "Easily record and share a video to show your appreciation to supporters.", buttonLabel: "Send a thank you", buttonHref: MOBILE_APP_IOS_LINK, buttonTarget: "_blank", imageUrl: sendAPersonalizedThankYouVideo, analytics: "sendThankYou", onDismiss: createOnDismiss(recommendationsDismiss.thankYou.dismiss) })),
        },
    };
};
